// const FundRaise = () => {
//     return (
//         <div>
//             <h1>Fund Raise</h1>
//         </div>
//     );
// }
// export default FundRaise;

import React from 'react';
import ComingSoon from '../../views/common/ComingSoon';

const FundRaise = () => {
  return <ComingSoon title="Fund Raise" />;
};

export default FundRaise; 